import {PriceList} from './price-list';

export class Product {

  productGuid!: string;
  active!: boolean;
  applicableForDiscount!: boolean;
  beginEffectiveDate!: Date;
  classCode!: string;
  commodityCode!: string;
  createTimestamp!: Date;
  createUser!: string;
  description!: string;
  descriptionShort!: string;
  diameter!: number;
  endEffectiveDate!: Date;
  configuration!: boolean;
  kit!: boolean;
  itemNumber!: string;
  externalNotes!: string;
  largeTextUserField1!: string;
  largeTextUserField2!: string;
  largeTextUserField3!: string;
  largeTextUserField4!: string;
  largeTextUserField5!: string;
  numericUserField1!: number;
  numericUserField2!: number;
  numericUserField3!: number;
  numericUserField4!: number;
  numericUserField5!: number;
  orderable!: boolean;
  productId!: string;
  productLineCode!: string;
  productModelCode!: string;
  productUomCode!: string;
  shippableItem!: boolean;
  spares!: boolean;
  typeCode!: string;
  updateTimestamp!: Date;
  updateUser!: string;
  vendorSupplied!: boolean;
  priceLists!: PriceList[];
  modular!: boolean;
  serialNumberRequired!: boolean;

}
